// Campaign Template Actions
import axios from 'axios';
import config from '../../config';
import { getUserToken } from '../../utils/helpers';

// Action Types
export const GET_CAMPAIGN_TEMPLATES = 'GET_CAMPAIGN_TEMPLATES';
export const GET_CAMPAIGN_TEMPLATES_SUCCESS = 'GET_CAMPAIGN_TEMPLATES_SUCCESS';
export const GET_CAMPAIGN_TEMPLATES_FAIL = 'GET_CAMPAIGN_TEMPLATES_FAIL';
export const GET_CAMPAIGN_TEMPLATES_RESET = 'GET_CAMPAIGN_TEMPLATES_RESET';

export const GET_CAMPAIGN_TEMPLATE_BY_ID = 'GET_CAMPAIGN_TEMPLATE_BY_ID';
export const GET_CAMPAIGN_TEMPLATE_BY_ID_SUCCESS = 'GET_CAMPAIGN_TEMPLATE_BY_ID_SUCCESS';
export const GET_CAMPAIGN_TEMPLATE_BY_ID_FAIL = 'GET_CAMPAIGN_TEMPLATE_BY_ID_FAIL';
export const GET_CAMPAIGN_TEMPLATE_BY_ID_RESET = 'GET_CAMPAIGN_TEMPLATE_BY_ID_RESET';

export const SAVE_CAMPAIGN_TEMPLATE = 'SAVE_CAMPAIGN_TEMPLATE';
export const SAVE_CAMPAIGN_TEMPLATE_SUCCESS = 'SAVE_CAMPAIGN_TEMPLATE_SUCCESS';
export const SAVE_CAMPAIGN_TEMPLATE_FAIL = 'SAVE_CAMPAIGN_TEMPLATE_FAIL';
export const SAVE_CAMPAIGN_TEMPLATE_RESET = 'SAVE_CAMPAIGN_TEMPLATE_RESET';

// Action Creators
export const getCampaignTemplatesReset = () => ({ type: GET_CAMPAIGN_TEMPLATES_RESET });
export const getCampaignTemplateByIdReset = () => ({ type: GET_CAMPAIGN_TEMPLATE_BY_ID_RESET });
export const saveCampaignTemplateReset = () => ({ type: SAVE_CAMPAIGN_TEMPLATE_RESET });

// Thunk: Get all templates (lightweight list)
export const getCampaignTemplatesApi = () => {
  return (dispatch) => {
    dispatch({ type: GET_CAMPAIGN_TEMPLATES });
    axios
      .get(`${config.api.base_url}/campaign-templates`, {
        headers: { Authorization: 'Bearer ' + getUserToken() },
      })
      .then((response) => {
        dispatch({ type: GET_CAMPAIGN_TEMPLATES_SUCCESS, response: response.data });
      })
      .catch((error) => {
        dispatch({ type: GET_CAMPAIGN_TEMPLATES_FAIL, response: error.response?.data || error.message });
      });
  };
};

// Thunk: Get single template by ID (full form_data)
export const getCampaignTemplateByIdApi = (id) => {
  return (dispatch) => {
    dispatch({ type: GET_CAMPAIGN_TEMPLATE_BY_ID });
    axios
      .get(`${config.api.base_url}/campaign-templates/${id}`, {
        headers: { Authorization: 'Bearer ' + getUserToken() },
      })
      .then((response) => {
        dispatch({ type: GET_CAMPAIGN_TEMPLATE_BY_ID_SUCCESS, response: response.data });
      })
      .catch((error) => {
        dispatch({ type: GET_CAMPAIGN_TEMPLATE_BY_ID_FAIL, response: error.response?.data || error.message });
      });
  };
};

// Thunk: Save a new template
export const saveCampaignTemplateApi = (data) => {
  return (dispatch) => {
    dispatch({ type: SAVE_CAMPAIGN_TEMPLATE });
    axios
      .post(`${config.api.base_url}/campaign-templates`, data, {
        headers: { Authorization: 'Bearer ' + getUserToken() },
      })
      .then((response) => {
        dispatch({ type: SAVE_CAMPAIGN_TEMPLATE_SUCCESS, response: response.data });
      })
      .catch((error) => {
        dispatch({ type: SAVE_CAMPAIGN_TEMPLATE_FAIL, response: error.response?.data || error.message });
      });
  };
};
